import React from 'react';
import { ApplicationView } from '@aha-app/mvc';
import Tool, { type IToolActionInput, type ToolButtonComponent } from './Tool';
import ToolButton from '../toolbars/ToolButton';
import { svgToIcon } from '../utils/svg';
import mergeCellsSVG from '../assets/icons/mergeCells.svg';
import unmergeCellsSVG from '../assets/icons/unmergeCells.svg';
import type Table from '../objects/Table';
import { isTable } from '../objects/guards';

const MergeCellsButton: ToolButtonComponent<Table> = ApplicationView(
  ({ controller, selection, tool }) => {
    const icon = selection.mergeable ? mergeCellsSVG : unmergeCellsSVG;

    return (
      <ToolButton
        onClick={() => {
          controller.actionApplyTool(tool);
        }}
        tool={tool}
      >
        {svgToIcon(icon)}
      </ToolButton>
    );
  }
);

class ToolTableMergeCells extends Tool {
  static toolName = 'Merge cells';

  static action({ selection }: IToolActionInput) {
    isTable(selection) && selection.mergeCells();
  }

  static buttonComponent() {
    return MergeCellsButton;
  }
}

class ToolTableUnmergeCells extends Tool {
  static toolName = 'Unmerge cells';

  static action({ selection }: IToolActionInput) {
    isTable(selection) && selection.unmergeCells();
  }

  static buttonComponent() {
    return MergeCellsButton;
  }
}

export { ToolTableMergeCells, ToolTableUnmergeCells };
